var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPressure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloudy_sunny",
    fill: "#ffe142"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bright",
    fill: "#ffe142"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cloudy",
    fill: "#ffe142"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "high_rainfall",
    fill: "#ffe142"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "windy",
    fill: "#ffe142"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "rain_with_thunder",
    fill: "#ffe142"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "clear_night",
    fill: "#ffe142"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "cloudy_night",
    fill: "#ffe142"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "moon",
    fill: "#ffe142"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "sun",
    fill: "#ffe142"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "rainy_night",
    fill: "#ffe142"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "windy_night",
    fill: "#ffe142"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "night_rain_thunder",
    fill: "#ffe142"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "windy_rain",
    fill: "#ffe142"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "temperature",
    fill: "#ffe142"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "humidity",
    fill: "#ffe142"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "air_pressure"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffe142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9,27.2l-7.6,12.9C32.9,40.1,32.5,40,32,40c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5c0-1.6-0.8-3-1.9-3.9l7.3-12.4    c2,2.3,3.3,5.2,3.5,8.4c0,0.5,0.5,0.9,1,0.9h3.4c0.5,0,0.8-0.3,1-0.7c0.5-1.7,0.7-3.5,0.7-5.3c0-11-9-20-20-20s-20,9-20,20    c0,1.8,0.2,3.6,0.7,5.3c0.1,0.4,0.5,0.7,1,0.7H17c0.5,0,1-0.4,1-0.9C18.5,29.7,24.6,24,32,24C35.4,24,38.5,25.2,40.9,27.2z M32,48    c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S33.7,48,32,48z M25.8,23.3l-2.9-6.7c0,0,0-0.1-0.1-0.1c2.4-1.4,5.2-2.3,8.1-2.5v8    C29.2,22.2,27.4,22.6,25.8,23.3z M33,22v-8c3,0.2,5.7,1,8.1,2.5c0,0,0,0.1-0.1,0.1l-2.9,6.7C36.6,22.6,34.8,22.2,33,22z M49.6,36    h-1.7c-0.3-2.3-1.1-4.4-2.2-6.3l3.6-2.7c0.5,1.6,0.7,3.2,0.7,5C50,33.4,49.8,34.7,49.6,36z M48.6,25.1c-0.1,0-0.2,0.1-0.2,0.1    l-3.9,2.9c-0.3-0.4-0.7-0.8-1.1-1.2l1.4-2.4c0.3-0.5,0.1-1.1-0.4-1.4c-0.5-0.3-1.1-0.1-1.4,0.4l-1.2,2c-0.6-0.5-1.3-0.9-1.9-1.3    l2.8-6.5C45.4,19.6,47.4,22.1,48.6,25.1z M16.1,36h-1.7c-0.3-1.3-0.4-2.6-0.4-4c0-1.7,0.3-3.4,0.7-5l3.6,2.7    C17.2,31.6,16.4,33.7,16.1,36z M19.5,28.1l-3.9-2.9c-0.1-0.1-0.1-0.1-0.2-0.1c1.2-3,3.3-5.5,5.8-7.5l2.8,6.5    C22.2,25.2,20.7,26.5,19.5,28.1z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "low_rainfall",
    fill: "#ffe142"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "moderate_rainfall",
    fill: "#ffe142"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Sunset",
    fill: "#ffe142"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/pressure.5df0eac86dcc70a92e599b7df8545368.svg";
export { ForwardRef as ReactComponent };